// Test IDs for the Cover Club feature. Naming follows the directive in
// ./auth.js (keys camelCase, values kebab-case `<feature>-<element>`).

export const COVER_CLUB = {
	page: 'cover-club-page',
	navLink: 'app-nav-cover-club',
	feed: 'cover-club-feed',
	card: 'cover-club-card',
	battle: 'cover-club-battle',
	collections: 'cover-club-collections',
};
